// Indian money and date helpers shared by the daily report and cash flow screens
export const inr = (n, { decimals = false } = {}) => {
    const v = Number(n) || 0;
    const hasPaise = Math.abs(v % 1) > 0.004;
    return `₹${v.toLocaleString('en-IN', { minimumFractionDigits: decimals || hasPaise ? 2 : 0, maximumFractionDigits: 2 })}`;
};
export const signed = (n) => `${n < 0 ? '−' : '+'} ${inr(Math.abs(n))}`;
export const todayYmd = () => new Date(Date.now() + 330 * 60000).toISOString().slice(0, 10);
export const shiftYmd = (ymd, days) => {
    const [y, m, d] = ymd.split('-').map(Number);
    return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
};
export const longDate = (ymd) => {
    const [y, m, d] = String(ymd || '').split('-').map(Number);
    if (!y) return '';
    return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
};
// Shop times are always shown in Indian time, whatever the phone's own timezone is
export const timeOf = (date) => (date ? new Date(date).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata' }) : '');
export const dateTimeOf = (date) => (date ? new Date(date).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata' }) : '');
export const hourLabel = (h) => `${((h + 11) % 12) + 1}${h < 12 ? 'a' : 'p'}`;
